import React from 'react';
import PropTypes from 'prop-types';

import EffectiveTaxRateDetailLink from './effectiveTaxRateDetailLink.component';
import CustomNumeral from '../../shared/customNumeral.component';
import { NumeralTypes } from '../../shared/numeral.component';

class GroupingColumns extends React.PureComponent {
  static propTypes = {
    hideGroupingColumns: PropTypes.bool,
    columnsData: PropTypes.arrayOf(PropTypes.number).isRequired,
    sumForPercentagesCalculation: PropTypes.number,
    suppressHidingDecimalPlacesForPercentage: PropTypes.bool,
    ibtAmount: PropTypes.number,
    tagName: PropTypes.string,
    account: PropTypes.string,
    countryTaxType: PropTypes.string,
    shouldRenderLink: PropTypes.bool,
  };

  static defaultProps = {
    hideGroupingColumns: false,
    suppressHidingDecimalPlacesForPercentage: false,
  };

  renderNumeral = columnAmount => {
    const {
      sumForPercentagesCalculation,
      suppressHidingDecimalPlacesForPercentage,
    } = this.props;

    return (
      sumForPercentagesCalculation
        ? (
          <CustomNumeral
            type={NumeralTypes.PERCENT_4}
            suppressHidingDecimalPlaces={suppressHidingDecimalPlacesForPercentage}
          >
            {columnAmount / sumForPercentagesCalculation}
          </CustomNumeral>
        )
        : <CustomNumeral type={NumeralTypes.DECIMAL}>{columnAmount}</CustomNumeral>
    );
  };

  renderCell = (columnAmount, index) => {
    if (!columnAmount) {
      return <div key={index} className="col-2 text-right" />;
    }

    const {
      tagName,
      account,
      countryTaxType,
      ibtAmount,
      shouldRenderLink,
    } = this.props;

    return (
      <div key={index} className="col-2 text-right">
        {
          shouldRenderLink
            ? (
              <EffectiveTaxRateDetailLink
                tagName={tagName}
                account={account}
                countryTaxType={countryTaxType}
                ibtAmount={ibtAmount}
                index={index}
              >
                {this.renderNumeral(columnAmount)}
              </EffectiveTaxRateDetailLink>
            )
            : this.renderNumeral(columnAmount)
        }
      </div>
    );
  };

  render = () => {
    const {
      hideGroupingColumns,
      columnsData,
    } = this.props;

    return (
      <div className="grouping-columns">
        { hideGroupingColumns || !columnsData
          ? null
          : columnsData.map(this.renderCell)
        }
      </div>
    );
  };
}

export default GroupingColumns;
